import { clsx } from 'clsx';
import { useEffect } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Text } from '@/components/text';
import { ANALYTICS_EVENTS } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

type Props = {
  className?: string;
};

export const CheckboxSelectionMessaging = ({
  className = '-mt-3 text-[14px] lg:mb-1 lg:text-[1rem]',
}: Props) => {
  const { electricityChecked, gasChecked, gasAvailable } = useJoinFormStore();

  /**
   * e.g. 11 Cator Street, GLENSIDE SA 5065 does not have gas
   *
   * If a customer has requested gas, but it is not available
   * - error message
   * otherwise if they did not request gas and gas is not available
   * - default message
   */

  useEffect(() => {
    if (!gasAvailable && gasChecked) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.gasNotOffered, {});
    }
  }, [gasAvailable, gasChecked]);

  return (
    <>
      {!gasAvailable && (
        <Text
          variant="body2"
          weight="semi"
          className={clsx(className, gasChecked && 'text-error')}
        >
          We don&apos;t currently offer gas at your location.
          {!electricityChecked && (
            <>
              <br />
              <span className="font-inherit">
                Please choose at least one of electricity or gas to proceed.
              </span>
            </>
          )}
        </Text>
      )}
      {!gasChecked && !electricityChecked && gasAvailable && (
        <Text
          variant="body2"
          weight="semi"
          className="mb-6 text-[14px] text-error lg:mb-7 lg:mt-2"
        >
          Please choose at least one of electricity or gas to proceed.
        </Text>
      )}
    </>
  );
};
